import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  id: "Legal",
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 39.039 37.29"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  id: "Tracé_1792",
  "data-name": "Tracé 1792",
  d: "M2.827,31.113,16.97,16.97l1.454,1.454,1.453,1.453L5.734,34.019ZM26.28,23.451l6.52-6.52,1.219,1.218L27.5,24.671Zm-2.711-2.71,6.521-6.52,1.3,1.3-6.52,6.52ZM25.456,6.757,26.922,5.29l4.634,4.635L30.09,11.391ZM19.837,17.01,16.97,14.143,12.177,9.349,18.7,2.828l9.978,9.978-6.521,6.521ZM18.7,0,9.348,9.349l6.208,6.208L0,31.113l5.734,5.734L21.291,21.291,27.5,27.5l9.349-9.35L31.5,12.806l2.88-2.881L26.922,2.462,24.041,5.343Z",
  fill: "#fff"
}, null, -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("rect", {
  id: "Rectangle_495",
  "data-name": "Rectangle 495",
  width: "21.631",
  height: "2",
  transform: "translate(17.408 35.29)",
  fill: "#fff"
}, null, -1)
const _hoisted_4 = [
  _hoisted_2,
  _hoisted_3
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_4))
}